var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_3960)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_106_3960)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.2295,
    cy: 16.4116,
    r: 28.8398,
    fill: "#1782FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_106_3960)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.99,
    cy: 20.0042,
    r: 26.8767,
    fill: "#50B7F0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_106_3960)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.4365,
    cy: 62.5494,
    r: 22.5635,
    fill: "#DC45EE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_106_3960)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.9234,
    cy: 58.9092,
    r: 26.2037,
    fill: "url(#paint0_linear_106_3960)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.8787 36.3936H62.3363V19.6113H19.6637V61.3888H62.3363V46.0365H53.8787V55.5884H28.3241V34.3413L41.5367 25.5026H53.8787V36.3936Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_106_3960",
    x: 11.3896,
    y: -32.4282,
    width: 97.6797,
    height: 97.6797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_106_3960"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_106_3960",
    x: -26.8867,
    y: -26.8726,
    width: 93.7534,
    height: 93.7534,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_106_3960"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_106_3960",
    x: -24.127,
    y: 19.9859,
    width: 85.127,
    height: 85.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_106_3960"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_106_3960",
    x: 13.7197,
    y: 12.7055,
    width: 92.4074,
    height: 92.4073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_106_3960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_3960",
    x1: 33.7197,
    y1: 37.0728,
    x2: 92.7817,
    y2: 48.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E58EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_3960"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.485809,
    y: 0.5,
    width: 81.0284,
    height: 80,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c93664d6a01039f22cad262457237c02.svg";
export { ForwardRef as ReactComponent };